module.exports = __webpack_public_path__ + "img/man_1_3.2868752d.png";